<template>
  <div
    class="mt-12 p-8 sm:p-10 rounded-2xl bg-degradado-h-bochas flex flex-col sm:flex-col items-center justify-between gap-8"
  >
    <div>
      <h3 class="text-xl sm:text-4xl font-bold text-white mb-2 text-center">
        {{ title }}
      </h3>
      <p class="text-sm sm:text-2xl font-medium text-white text-center">
        {{ description }}
      </p>
    </div>
    <div class="w-full sm:w-auto">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
});
</script>
